import { lazy } from "react";

const MainPage = lazy(() => import("./views/home/index.js"));

const routes = [
  {
    path: "/medical-dispensaries/appointments",
    exact: true,
    name: "Citas de Dispensarios Médicos",
    component: MainPage
  }
];

export default routes;
